var app = angular.module('leonardo');

var AutocompleteFilter = function () {
  var strStartsWith = function(str, prefix) {
    if(!isNull(str)){
      return (str.toLowerCase()+"").indexOf(prefix.toLowerCase()) === 0;
    }
  };

  return function (value, options) {
    var filtered = [];
    var name = '';
    if (value) {
      angular.forEach(options, function(item) {
        name = item.name ? item.name : item;
        if(strStartsWith(name, value)){
          filtered.push(item);
        }
      });
    }
    else {
      angular.forEach(options, function(item) {
        filtered.push(item);
      });
    }

    return filtered;
  }
};

app.filter('autocomplete', [AutocompleteFilter]);
